<template>
  <li
    class="column is-one-quarter-desktop is-one-third-tablet is-half-mobile"
    @click="onClick(liveId)"
  >
    <div class="thumbnail">
      <b-image :src="imageSrc" ratio="400by255" />
    </div>
    <p class="is-size-6">{{ nickname }}</p>
    <p class="is-size-7">{{ genre }}</p>
  </li>
</template>

<script>
export default {
  name: 'LiveListedTile',
  props: {
    tileData: {
      type: Object,
      default() {
        return {
          liveId: 'dummy',
          imageSrc: 'http://placehold.jp/400x255.png',
          nickname: 'なまえ名前なまえ名前',
          genre: '特技配信ジャンル特技配信ジャンル'
        };
      }
    },
    onClick: null
  },
  computed: {
    liveId() {
      return this.tileData.liveId;
    },
    link() {
      return this.tileData.link;
    },
    imageSrc() {
      return this.tileData.imageSrc;
    },
    nickname() {
      return this.tileData.nickname;
    },
    genre() {
      return this.tileData.genre;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/home.scss';

li {
  cursor: pointer;
}
</style>
